import { redirect, type RouteObject } from 'react-router'
import { Outlet } from 'react-router-dom'

import { createRouteModeAnchor } from '../client/components/Admin/TopNavBar/modes/index.js'
import { routeCrumb } from '../client/components/Admin/TopNavBar/utils/routeCrumb.js'

export const moderationRoutes: RouteObject = {
  path: 'settings/moderation',
  async lazy() {
    const { ModerationRootRoute, ModerationBreadcrumb } = await import(
      '../client/components/Moderation/ModerationRootRoute.js'
    )

    return {
      Component: ModerationRootRoute,
      handle: routeCrumb(ModerationBreadcrumb),
    }
  },
  children: [
    {
      index: true,
      loader: () => redirect('all/draft-posts'),
    },
    {
      path: ':spaceId',
      async lazy() {
        const {
          ModerationSpaceBreadcrumb,
          ModerationSpaceAnchorToAdmin,
          ModerationSpaceAnchorToDesign,
        } = await import('../client/components/Moderation/index.js')

        return {
          Component: Outlet,
          handle: {
            ...routeCrumb(ModerationSpaceBreadcrumb),
            ...createRouteModeAnchor({
              admin: ModerationSpaceAnchorToAdmin,
              design: ModerationSpaceAnchorToDesign,
            }),
          },
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('draft-posts'),
        },
        {
          path: ':section?',
          async lazy() {
            const { Moderation, ModerationSectionBreadcrumb } = await import(
              '../client/components/Moderation/index.js'
            )

            return {
              Component: Moderation,
              handle: routeCrumb(ModerationSectionBreadcrumb),
            }
          },
        },
      ],
    },
  ],
}
